<template>
  <div class="map_selector">
    Select a map
    <router-link v-for="map in maps" :key="map.id" :to="{name: 'map', params: { mapId: map.id }}" class="button map_selector__map_button">{{ map.name }}</router-link>
    <router-link :to="{name: 'mapsForm'}" class="button creative">New map</router-link>
  </div>
</template>

<script>
export default {
  name: 'MapSelector',
  computed: {
    maps () { return this.$store.getters.maps },
  },
}
</script>
